export default {
	"ordersMultiple": {
		"lasterStartTime": "latest start time",
		"lasterFinishTime": "latest completion time",
		"taskDetail": "Task details",
		"actualPackingQty": "Actual number of outer packaging",
		"warningTimes": "Number of alerts",
		"completeBackDt": "Receipt completion time",
		"finishLocationQty": "number of locations completed",
		"finishTransportQty": "Number of tasks completed",
		"processInformation": "Process information",
		"BillingStatus": "billing status",
		"settlementTime": "settlement time",
		"reckoner": "clearing party",
		"payor": "payee"
	},
	"ordersSingle": {
		"transportStop": "Shipment terminated",
		"changeTransport": "divert",
		"demandInfo": "demand information",
		"receiving": "Receipt",
		"taskExecutPreview": "Task execution list",
		"executeInfo": "execution information",
		"signName": "signee",
		"backRemarks": "Receipt remarks",
		"commonbackCheckedStatus": "Receipt status"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/orders/orders.js